import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { OFFBOARDING } from "../config/apiEndPoint";
import { DEL, GET, POST, PUT } from "config/api.config";

export const getOffboardingList = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${OFFBOARDING.GET_OFFBOARDING_LIST}/${data?._Id}`
      : `${OFFBOARDING.GET_OFFBOARDING_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addOffboarding = async (data = array()) => {
  try {
    const response = await POST(OFFBOARDING.ADD_OFFBOARDING, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateOffboarding = async (id, data = array()) => {
  try {
    const url = `${OFFBOARDING.ADD_OFFBOARDING}/${id}`;
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getOffboardingDataById = async (data = array()) => {
  try {
    const url = data?.Id
      ? `${OFFBOARDING.GET_OFFBOARDING_LIST}/${data?.Id}`
      : `${OFFBOARDING.GET_OFFBOARDING_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchOffboardingTableAndFilterSchema = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${OFFBOARDING.GET_OFFBOARDING_SCHEMA}/${data?._Id}`
      : `${OFFBOARDING.GET_OFFBOARDING_SCHEMA}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitOffboardingFilterData = async (data = array()) => {
  try {
    const response = await POST(OFFBOARDING.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** DELETE `client/Offboarding/{id}` */
export const deleteOffboarding = async (id = "") => {
  const raw = String(id ?? "").trim();
  if (!raw) return null;
  try {
    const response = await DEL(OFFBOARDING.DELETE_BY_ID(raw));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getOffboardingByClientId = async (clientId = "") => {
  try {
    const resolvedClientId = String(clientId ?? "").trim();
    if (!resolvedClientId) {
      toast.error("Client id is missing");
      return null;
    }
    const response = await GET(OFFBOARDING.GET_BY_CLIENT(resolvedClientId));
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
